import React from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';

import LinkForm from './link-form';

import './styles/modal.scss';

class LinkModal extends React.Component {
  handleSubmit = ({ name, url }) => {
    this.props.onUpdate({
      name,
      url,
    });

    this.props.onClose();
  }

  render() {
    const { name, url, id, brandfolderKey, onClose } = this.props;

    const isNew = name === '' && url === '';

    return (
      <ReactModal
        isOpen
        closeTimeout={500}
        overlayClassName="react-modal-overlay"
        className="react-modal-content"
        shouldCloseOnEsc
        shouldCloseOnOverlayClick
        onRequestClose={onClose}
        shouldReturnFocusAfterClose
        shouldFocusAfterRender
        ariaHideApp
      >
        <div className="link-modal__body">
          <h2 className="link-modal__header">
            {isNew ? t('New link') : t('Edit link')}
          </h2>
          <div className="link-modal__content">
            <LinkForm
              name={name}
              url={url}
              id={id}
              onSubmit={this.handleSubmit}
              onCancel={onClose}
              brandfolderKey={brandfolderKey}
            />
          </div>
        </div>
      </ReactModal>
    );
  }
}

LinkModal.propTypes = {
  name: PropTypes.string,
  url: PropTypes.string,
  id: PropTypes.string,
  brandfolderKey: PropTypes.string.isRequired,
  onUpdate: PropTypes.func,
  onClose: PropTypes.func,
};

LinkModal.defaultProps = {
  name: '',
  url: '',
  id: null,
  onUpdate: () => {},
  onClose: () => {},
};

export default LinkModal;
